var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEckoWalletFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151,
    height: 125,
    viewBox: "0 0 151 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-footer-logo",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    gradientTransform: "rotate(20)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-footer-logo-2",
    x1: -0.203,
    y1: -0.134,
    x2: 0.9,
    y2: 0.1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112678",
    "data-name": "Group 112678",
    transform: "translate(-164.135 -92.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143464",
    "data-name": "Path 143464",
    d: "M-1489.31,6504.585l-3.67-3.685-8.1-8.129,8.1-8.13,3.67-3.682,3.671,3.682,8.1,8.13-8.1,8.129Zm0,11.392v24.293l-35.233-35.358,12.107-12.144Zm-35.233-35.348v24.283l12.107-12.144,23.126-23.2V6445.27Z",
    transform: "translate(1740.678 -6352.882)",
    fill: "url(#linear-gradient-footer-logo)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112655",
    "data-name": "Group 112655",
    transform: "translate(164.135 197.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77852-2",
    "data-name": "Group 77852-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74956",
    "data-name": "Path 74956",
    d: "M3324.131-2397.064a7.087,7.087,0,0,0-7.317,7.333,7.066,7.066,0,0,0,7.393,7.285,6.77,6.77,0,0,0,6.858-4.763h-3.773a3.24,3.24,0,0,1-3.11,1.758,3.473,3.473,0,0,1-3.645-3.361h10.758C3331.65-2393.422,3328.77-2397.064,3324.131-2397.064Zm-3.417,5.578a3.4,3.4,0,0,1,3.392-2.574,3.264,3.264,0,0,1,3.314,2.574Z",
    transform: "translate(-3316.813 2402.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74957",
    "data-name": "Path 74957",
    d: "M3409.675-2385.808a3.582,3.582,0,0,1-3.6-3.948,3.572,3.572,0,0,1,3.621-3.947,3.159,3.159,0,0,1,3.237,2.267h3.748c-.535-3.566-3.569-5.628-6.985-5.628a7.125,7.125,0,0,0-7.317,7.308,7.121,7.121,0,0,0,7.292,7.31c3.365,0,6.449-1.962,7.01-5.654h-3.748A3.189,3.189,0,0,1,3409.675-2385.808Z",
    transform: "translate(-3386.912 2402.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74958",
    "data-name": "Path 74958",
    d: "M3526.353-2342.375h-4.667l-4.6-5.412h4.7Z",
    transform: "translate(-3480.873 2361.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74959",
    "data-name": "Path 74959",
    d: "M3501.268-2420.791l-6.4,6.672-2.437,2.429-1.132,1.129v3.777h-3.647v-19.61h3.647v11.435l5.329-5.832Z",
    transform: "translate(-3456.765 2426.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74960",
    "data-name": "Path 74960",
    d: "M3565.854-2397.064a7.18,7.18,0,0,0-7.29,7.308,7.164,7.164,0,0,0,7.29,7.31,7.156,7.156,0,0,0,7.317-7.31A7.185,7.185,0,0,0,3565.854-2397.064Zm0,11.155a3.6,3.6,0,0,1-3.62-3.847,3.612,3.612,0,0,1,3.62-3.846,3.614,3.614,0,0,1,3.622,3.846,3.6,3.6,0,0,1-3.622,3.847Z",
    transform: "translate(-3514.853 2402.362)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Group_77896",
    "data-name": "Group 77896",
    d: "M3669.2-2413.4h4.4l-4.278,17.565h-5.291l-1.543-6.349-.912-6.2-.43-.025-.886,6.223-1.544,6.349H3653.4l-4.278-17.565h4.429l2.025,8.406.531,4.09.532-4.09,2.025-8.406h5.391l2.025,8.406.557,4.19.531-4.19Zm24.55,13.5h7.189v4.065h-11.492V-2413.4h4.3Zm12.342,0h7.189v4.065h-11.492V-2413.4h4.3Zm33.951-13.5v4.065h-4.835v13.5h-4.3v-13.5h-4.809v-4.065Zm-56.191,17.652-.986-2.959h-6.374l-.986,2.959h-4.6l6.171-17.652h5.261l6.146,17.652Zm-6.272-6.219h4.2l-2.1-6.269Zm47.5-7.325h-6.465v2.61h5.7v4.065h-5.7v2.76h6.465v4.065h-10.768v-17.565h10.768Z",
    transform: "translate(-3589.041 2415.744)",
    fill: "url(#linear-gradient-footer-logo-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckoWalletFooter);
export default __webpack_public_path__ + "static/media/eckoWALLET_footer.3ae6ba2489a19365c962f826f2948d86.svg";
export { ForwardRef as ReactComponent };